import React, {useEffect, useRef, useState} from 'react';
import {GLTF, GLTFLoader} from 'three/examples/jsm/loaders/GLTFLoader.js';
import {sceneEngine, sceneType} from './sceneEngine';
import {
  AdditiveAnimationBlendMode,
  AnimationAction, AnimationClip,
  AnimationMixer, AudioLoader,
  Clock,
  Color,
  DirectionalLight,
  DoubleSide,
  HemisphereLight, InterpolateLinear,
  LoopPingPong, Mesh,
  NumberKeyframeTrack,
  PerspectiveCamera,
  Scene,
  Vector3,
  WebGLRenderer,
  AudioListener as Three_AudioListener,
  Audio as Three_Audio,
  AudioLoader as Three_AudioLoader, Quaternion, Euler, SRGBColorSpace
} from 'three';
import {amy3DHolderType, amyMorphtargets} from './scene3DTypes';
import {castUndefined} from '@shared/typescript/typescriptExtensions';
import {FBXLoader} from 'three/examples/jsm/loaders/FBXLoader.js';
import {Dict} from "@shared/types/valueTypes";
import scubeContext from "@core/scubeContext";
import {LoopOnce} from "three/src/constants.js";
import amy3D from "@amy/amyWebGL/amy3D";


//https://docs.aws.amazon.com/polly/latest/dg/viseme.html

//https://docs.aws.amazon.com/polly/latest/dg/ph-table-english-us.html

//http://www.zxthex.com/Viseme%20Reference%20_%20Oculus%20Developers.html
//https://developer.oculus.com/documentation/unity/audio-ovrlipsync-viseme-reference/
//https://learn.microsoft.com/en-us/azure/ai-services/speech-service/how-to-speech-synthesis-viseme?tabs=visemeid&pivots=programming-language-csharp


declare global {
  interface Window {
    mixerHeadTime: number;
    mixerHeadFinishedFx: () => void;
    amyModelHeadVector: Vector3;
    amyModelHeadDirectionQ: Quaternion;
    amyModelHeadDirectionEuler: Euler;
    lastAudioVolume: number;
    delta: number;
  }
}

type vowelIpaVisemeType = { azVisemeId: string, playerViseme: string }
const visemesByNumber: Dict<vowelIpaVisemeType> = {}

let vowelIpaViseme = function (azVisemeId, ipaNameExamplePairsArray, awsVisemes, playerViseme) {
  this.azVisemeId = azVisemeId.toString();
  this.ipaNameExamplePairsArray = ipaNameExamplePairsArray;
  this.awsVisemes = awsVisemes;
  this.playerViseme = 'viseme_' + playerViseme;

  visemesByNumber[this.azVisemeId] = this;
}

let mapVowelIpaVisemeTable = [
  new vowelIpaViseme(0, [], [], 'sil'),
  new vowelIpaViseme(1, [['æ', '[a]ctive'], ['ʌ', '[u]ncle'], ['ə', '[a]go'], ['ɚ', 'all[er]gy']], ['a', '@', 'E'], 'aa'),
  new vowelIpaViseme(2, [['ɑ', '[o]bstinate'], ['ɑɹ', '[ar]tist']], ['a'], 'aa'),
  new vowelIpaViseme(3, [['ɔ', 'c[au]se'], ['ɔɹ', '[or]ange']], ['O'], 'O'),
  new vowelIpaViseme(4, [['eɪ', '[a]te'], ['ɛ', '[e]very'], ['ʊ', 'b[oo]k'], ['ɛɹ', '[air]plane'], ['ʊɹ', 'c[ur]e']], ['e', 'E', 'u'], 'E'),
  new vowelIpaViseme(5, [['ɝ', '[ear]th']], ['E'], 'aa'),
  new vowelIpaViseme(6, [['i', '[ea]t'], ['ɪ', '[i]f'], ['ju', '[Yu]ma'], ['ɪɹ', '[ear]s'], ['j', '[y]ard, f[e]w']], ['i'], 'I'),
  new vowelIpaViseme(7, [['u', '[U]ber'], ['ju', '[Yu]ma'], ['w', '[w]ith, s[ue]de']], ['u'], 'U'),
  new vowelIpaViseme(8, [['oʊ', '[o]ld']], ['o'], 'O'),
  new vowelIpaViseme(9, [['aʊ', '[ou]t'], ['aʊ(ə)ɹ', '[hour]s']], ['a'], 'aa'),
  new vowelIpaViseme(10, [['ɔɪ', '[oi]l']], ['O'], 'O'),
  new vowelIpaViseme(11, [['aɪ', '[i]ce'], ['aɪ(ə)ɹ', '[Ire]land']], ['a'], 'aa'),
  new vowelIpaViseme(12, [['h', '[h]elp']], ['k'], 'kk'),
  new vowelIpaViseme(13, [['ɪɹ', '[ear]s'], ['ɛɹ', '[air]plane'], ['ʊɹ', 'c[ur]e'], ['aɪ(ə)ɹ', '[Ire]land'], ['aʊ(ə)ɹ', '[hour]s'],
    ['ɔɹ', '[or]ange'], ['ɑɹ', '[ar]tist'], ['ɝ', '[ear]th'], ['ɚ', 'all[er]gy'], ['ɹ', '[r]ed, b[r]ing']], ['r'], 'RR'),
  new vowelIpaViseme(14, [['l', '[l]id, g[l]ad']], ['t'], 'DD'),
  new vowelIpaViseme(15, [['s', '[s]it'], ['z', '[z]ap']], ['s'], 'SS'),
  new vowelIpaViseme(16, [['ʃ', '[sh]e'], ['ʒ', '[J]acques'], ['tʃ', '[ch]in'], ['dʒ', '[j]oy']], ['S'], 'CH'),
  new vowelIpaViseme(17, [['θ', '[th]in'], ['ð', '[th]en']], ['T'], 'TH'),
  new vowelIpaViseme(18, [['f', '[f]ork'], ['v', '[v]alue']], ['f'], 'FF'),
  new vowelIpaViseme(19, [['t', '[t]alk'], ['d', '[d]ig'], ['n', '[n]o, s[n]ow']], ['t'], 'DD'),
  new vowelIpaViseme(20, [['k', '[c]ut'], ['g', '[g]o'], ['ŋ', 'li[n]k']], ['k'], 'kk'),
  new vowelIpaViseme(21, [['p', '[p]ut'], ['b', '[b]ig'], ['m', '[m]at, s[m]ash']], ['p'], 'PP')
]

//console.log(visemesByNumber);

const initControls = (sceneHolder: amy3DHolderType) => {
};

const reloadModel = (result: amy3DHolderType) => {
  let self = result;
  result.amySettings = castUndefined(sceneEngine.curSceneContext?.currentScene?.amySettings);

  if (self.curAnimationModel) {
    self.bufferScene.remove(self.curAnimationModel);
  }

  function traverseMaterials(object: any, callback: any) {
    object.traverse((node: any) => {
      if (!node.isMesh) return;
      const materials = Array.isArray(node.material) ? node.material : [node.material];
      materials.forEach(callback);
    });
  }

  const updateTextureEncoding = (curContent: any) => {
    //const encoding = sRGBEncoding; //this.state.textureEncoding === 'sRGB' ? sRGBEncoding : LinearEncoding;
    traverseMaterials(curContent, (material: any) => {
      // if (material.map) material.map.encoding = encoding;
      // if (material.emissiveMap) material.emissiveMap.encoding = encoding;
      // if (material.map || material.emissiveMap) material.needsUpdate = true;
    });
  };

  let loader = new GLTFLoader();
  //let fbxLoader = new FBXLoader();
  //const modelMePath = '/models/a86d4fbe-1443-4fd7-a10e-5d5807dc73f0.glb';
  //let modelPath = '/models/' + sceneEngine.curSceneContext?.currentScene?.modelName + '?v=' + window.staticfilesversion;
  //let modelPath = '/models/wariorIdleMale.glb';

  async function loadModels() {
    function processAnimations(animationName: string, objectAnim: GLTF, objectModel: GLTF) {
      for (let i = 0; i < objectAnim.animations.length; i++) {
        //var clip2 = AnimationClip.parse(AnimationClip.toJSON(clip));
        const curAnim = objectAnim.animations[i];
        if (curAnim.duration > 10.0) {
          curAnim.duration = 10.0;
          if (curAnim.tracks) {
            //console.log('skratene');
            curAnim.tracks.forEach((track) => track.trim(0, 10.0));
          }
        }
      }

      for (let i = 0; i < objectAnim.animations.length; i++) {
        let action = self.mixer.clipAction(objectAnim.animations[i]);
        //action.setDuration(1.0);

        //rename animation
        (action as any)._clip.name = animationName;

        self.modelAnimations.push(action);
        self.modelAnimationsNamed[(action as any)._clip.name] = action;

        //console.log((action as any)._clip.name);
      }
    }

    let modelPath =
      '/models/' + sceneEngine.curSceneContext?.currentScene?.modelName + '?v=' + window.staticfilesversion;
    modelPath = modelPath.replace('amy', 'amy20');

    const modelGlb: GLTF = await loader.loadAsync(modelPath);

    //const extName = '.glb';
    const extName = '_pack08.glb';

    const animWavingPromise = loader.loadAsync('/models/Waving' + extName);
    const animWaving2Promise = loader.loadAsync('/models/Waving2' + extName);
    const animBashfulPromise = loader.loadAsync('/models/Bashful' + extName);
    const animHandRaisingPromise = loader.loadAsync('/models/HandRaising' + extName);
    const animHappyPromise = loader.loadAsync('/models/Happy' + extName);
    const animJumpingPromise = loader.loadAsync('/models/Jumping' + extName);
    const animLookingPromise = loader.loadAsync('/models/Looking' + extName);
    const animLooking2Promise = loader.loadAsync('/models/Looking2' + extName);
    const animLookingBehindPromise = loader.loadAsync('/models/LookingBehind' + extName);
    const animMacarenaDancePromise = loader.loadAsync('/models/MacarenaDance' + extName);
    const animNoPromise = loader.loadAsync('/models/No' + extName);
    const animPointingPromise = loader.loadAsync('/models/Pointing' + extName);
    const animReactingPromise = loader.loadAsync('/models/Reacting' + extName);
    const animRopeClimbPromise = loader.loadAsync('/models/RopeClimb' + extName);
    const animRumbaDancingPromise = loader.loadAsync('/models/RumbaDancing' + extName);
    const animSalsaDancingPromise = loader.loadAsync('/models/SalsaDancing' + extName);
    const animSillyDancingPromise = loader.loadAsync('/models/SillyDancing' + extName);
    const animStandingGreetingPromise = loader.loadAsync('/models/StandingGreeting' + extName);
    const animStandingUsingTouchscreenTabletPromise = loader.loadAsync(
      '/models/StandingUsingTouchscreenTablet' + extName
    );
    const animTalkingOnPhonePromise = loader.loadAsync('/models/TalkingOnPhone' + extName);
    const animTellingASecretPromise = loader.loadAsync('/models/TellingASecret' + extName);
    const animThankfulPromise = loader.loadAsync('/models/Thankful' + extName);
    const animWalkingPromise = loader.loadAsync('/models/Walking' + extName);
    const animYawnPromise = loader.loadAsync('/models/Yawn' + extName);
    const animYesPromise = loader.loadAsync('/models/Yes' + extName);
    const animStandingIdlePromise = loader.loadAsync('/models/StandingIdle' + extName);

    // const animWavingPromise = fbxLoader.loadAsync('/models/Waving.fbx.glb');
    // const animWaving2Promise = fbxLoader.loadAsync('/models/Waving2.fbx.glb');
    // const animBashfulPromise = fbxLoader.loadAsync('/models/Bashful.fbx.glb');
    // const animHandRaisingPromise = fbxLoader.loadAsync('/models/HandRaising.fbx.glb');
    // const animHappyPromise = fbxLoader.loadAsync('/models/Happy.fbx.glb');
    // const animJumpingPromise = fbxLoader.loadAsync('/models/Jumping.fbx.glb');
    // const animLookingPromise = fbxLoader.loadAsync('/models/Looking.fbx.glb');
    // const animLooking2Promise = fbxLoader.loadAsync('/models/Looking2.fbx.glb');
    // const animLookingBehindPromise = fbxLoader.loadAsync('/models/LookingBehind.fbx.glb');
    // const animMacarenaDancePromise = fbxLoader.loadAsync('/models/MacarenaDance.fbx.glb');
    // const animNoPromise = fbxLoader.loadAsync('/models/No.fbx.glb');
    // const animPointingPromise = fbxLoader.loadAsync('/models/Pointing.fbx.glb');
    // const animReactingPromise = fbxLoader.loadAsync('/models/Reacting.fbx.glb');
    // const animRopeClimbPromise = fbxLoader.loadAsync('/models/RopeClimb.fbx.glb');
    // const animRumbaDancingPromise = fbxLoader.loadAsync('/models/RumbaDancing.fbx.glb');
    // const animSalsaDancingPromise = fbxLoader.loadAsync('/models/SalsaDancing.fbx.glb');
    // const animSillyDancingPromise = fbxLoader.loadAsync('/models/SillyDancing.fbx.glb');
    // const animStandingGreetingPromise = fbxLoader.loadAsync('/models/StandingGreeting.fbx.glb');
    // const animStandingUsingTouchscreenTabletPromise = fbxLoader.loadAsync(
    //   '/models/StandingUsingTouchscreenTablet.fbx.glb'
    // );
    // const animTalkingOnPhonePromise = fbxLoader.loadAsync('/models/TalkingOnPhone.fbx.glb');
    // const animTellingASecretPromise = fbxLoader.loadAsync('/models/TellingASecret.fbx.glb');
    // const animThankfulPromise = fbxLoader.loadAsync('/models/Thankful.fbx.glb');
    // const animWalkingPromise = fbxLoader.loadAsync('/models/Walking.fbx.glb');
    // const animYawnPromise = fbxLoader.loadAsync('/models/Yawn.fbx.glb');
    // const animYesPromise = fbxLoader.loadAsync('/models/Yes.fbx.glb');
    // const animStandingIdlePromise = fbxLoader.loadAsync('/models/StandingIdle.fbx.glb');

    const animWaving = await animWavingPromise;
    const animWaving2 = await animWaving2Promise;
    const animBashful = await animBashfulPromise;
    const animHandRaising = await animHandRaisingPromise;
    const animHappy = await animHappyPromise;
    const animJumping = await animJumpingPromise;
    const animLooking = await animLookingPromise;
    const animLooking2 = await animLooking2Promise;
    const animLookingBehind = await animLookingBehindPromise;
    const animMacarenaDance = await animMacarenaDancePromise;
    const animNo = await animNoPromise;
    const animPointing = await animPointingPromise;
    const animReacting = await animReactingPromise;
    const animRopeClimb = await animRopeClimbPromise;
    const animRumbaDancing = await animRumbaDancingPromise;
    const animSalsaDancing = await animSalsaDancingPromise;
    const animSillyDancing = await animSillyDancingPromise;
    const animStandingGreeting = await animStandingGreetingPromise;
    const animStandingUsingTouchscreenTablet = await animStandingUsingTouchscreenTabletPromise;
    const animTalkingOnPhone = await animTalkingOnPhonePromise;
    const animTellingASecret = await animTellingASecretPromise;
    const animThankful = await animThankfulPromise;
    const animWalking = await animWalkingPromise;
    const animYawn = await animYawnPromise;
    const animYes = await animYesPromise;
    const animStandingIdle = await animStandingIdlePromise;

    //process model

    //normalize model and materials
    updateTextureEncoding(modelGlb.scene);

    modelGlb.scene.scale.set(100, 100, 100); // scale here
    self.bufferScene.add(modelGlb.scene);

    self.mixer = new AnimationMixer(modelGlb.scene);

    self.mixer.addEventListener('loop', onLoopFinished);

    function onLoopFinished(event: any) {
      //console.log('finished');
      sceneEngine.animationFinished(event.action._clip.name);
    }

    //var newMaterial = new MeshBasicMaterial({ color: 0xff00ff });

    modelGlb.scene.traverse(function (child) {
      child.frustumCulled = false;
    });

    modelGlb.scene.traverse(function (child: any) {
      if (child.isMesh) {
        // TOFIX RoughnessMipmapper seems to be broken with WebGL 2.0
        // roughnessMipmapper.generateMipmaps( child.material );
        //console.log(child);
        //console.log(child.material);
        //child.material = newMaterial;

        child.material.side = DoubleSide; //DoubleSide;
        //child.material.transparent = true;
        //child.material.opacity = 0.1;
      }
    });

    //find bones
    const boneWorldPos = new Vector3();
    (self as any).headBone =  modelGlb.scene.getObjectByName('HeadTop_End');
    (self as any).headBone.getWorldPosition(boneWorldPos);
    console.log(boneWorldPos);


    self.modelAnimations = [];
    self.modelAnimationsNamed = {};

    processAnimations('Waving', animWaving, modelGlb);
    processAnimations('Waving2', animWaving2, modelGlb);
    processAnimations('Bashful', animBashful, modelGlb);
    processAnimations('HandRising', animHandRaising, modelGlb);
    processAnimations('Happy', animHappy, modelGlb);
    processAnimations('Jump', animJumping, modelGlb);
    processAnimations('Looking', animLooking, modelGlb);
    processAnimations('Looking2', animLooking2, modelGlb);
    processAnimations('LookingBehind', animLookingBehind, modelGlb);
    processAnimations('Macarena', animMacarenaDance, modelGlb);
    processAnimations('No', animNo, modelGlb);
    processAnimations('Pointing', animPointing, modelGlb);
    processAnimations('Reacting', animReacting, modelGlb);
    processAnimations('Climbing', animRopeClimb, modelGlb);
    processAnimations('RumbaDancing', animRumbaDancing, modelGlb);
    processAnimations('Salsa', animSalsaDancing, modelGlb);
    processAnimations('SillyDancing', animSillyDancing, modelGlb);
    processAnimations('Greeting', animStandingGreeting, modelGlb);
    processAnimations('Tablet', animStandingUsingTouchscreenTablet, modelGlb);
    processAnimations('*', animTalkingOnPhone, modelGlb);
    processAnimations('Secret', animTellingASecret, modelGlb);
    processAnimations('Thankful', animThankful, modelGlb);
    processAnimations('Walking', animWalking, modelGlb);
    processAnimations('Yawn', animYawn, modelGlb);
    processAnimations('Yes', animYes, modelGlb);
    processAnimations('Idle', animStandingIdle, modelGlb);


    //amy head and visemes
    //console.log(modelGlb as any);
    const visemeMesh = modelGlb.scene.getObjectByName('Wolf3D_Head');
    const visemeMeshTeeth = modelGlb.scene.getObjectByName('Wolf3D_Teeth');
    const visemeMeshEyeLeft = modelGlb.scene.getObjectByName('EyeLeft');
    //const visemeMeshEyeRight = modelGlb.scene.getObjectByName('EyeRight');

    //console.log(visemeMesh);
    //const meshAmy = visemeMesh as any;

    //draco
    const meshAmy = visemeMesh.children[0] as Mesh;
    const meshAmyTeeth = visemeMeshTeeth.children[0] as Mesh;
    const meshAmyEyeLeft = visemeMeshEyeLeft.children[0] as Mesh;
    //const meshAmyEyeRight = visemeMeshEyeRight.children[0] as Mesh;

    //non draco original
    // const meshAmy = visemeMesh as Mesh;
    // const meshAmyTeeth = visemeMeshTeeth as Mesh;
    // const meshAmyEyeLeft = visemeMeshEyeLeft as Mesh;
    // const meshAmyEyeRight = visemeMeshEyeRight as Mesh;


    const mixerHead = new AnimationMixer(meshAmy);
    (self as any).mixerHead = mixerHead;
    const mixerTeeth = new AnimationMixer(meshAmyTeeth);
    (self as any).mixerTeeth = mixerTeeth;

    const mixerEyeLeft = new AnimationMixer(meshAmy);
    (self as any).mixerEyeLeft = mixerEyeLeft;

    function onHeadFinished2(event: any) {
      if (window.mixerHeadFinishedFx) {
        window.mixerHeadFinishedFx();
      }
    }

    (self as any).mixerHead.addEventListener('finished', onHeadFinished2);


    // const viseme_PP_sil = meshAmy.morphTargetDictionary['viseme_sil'];
    // const viseme_PP_Pos = meshAmy.morphTargetDictionary['viseme_PP'];
    // const viseme_FF_Pos = meshAmy.morphTargetDictionary['viseme_FF'];
    // const viseme_TH_Pos = meshAmy.morphTargetDictionary['viseme_TH'];
    // const viseme_DD_Pos = meshAmy.morphTargetDictionary['viseme_DD'];
    // const viseme_kk_Pos = meshAmy.morphTargetDictionary['viseme_kk'];
    // const viseme_CH_Pos = meshAmy.morphTargetDictionary['viseme_CH'];
    // const viseme_SS_Pos = meshAmy.morphTargetDictionary['viseme_SS'];
    // const viseme_nn_Pos = meshAmy.morphTargetDictionary['viseme_nn'];//--
    // const viseme_RR_Pos = meshAmy.morphTargetDictionary['viseme_RR'];
    // const viseme_aa_Pos = meshAmy.morphTargetDictionary['viseme_aa'];
    // const viseme_E_Pos = meshAmy.morphTargetDictionary['viseme_E'];//--d
    // const viseme_I_Pos = meshAmy.morphTargetDictionary['viseme_I'];
    // const viseme_O_Pos = meshAmy.morphTargetDictionary['viseme_O'];
    // const viseme_U_Pos = meshAmy.morphTargetDictionary['viseme_U'];


    // create an AudioListener and add it to the camera
    const listener = new Three_AudioListener();
    self.bufferCamera.add(listener);

    const sound = new Three_Audio(listener);

    self.sound = sound;

    scubeContext.toggleMuteUserAudioFx = (mute: boolean) =>{
        if(mute)
        {
          window.lastAudioVolume =  sound.getVolume();
          sound.setVolume(0.0);
        }else{
          sound.setVolume(window.lastAudioVolume);
        }
    };

    scubeContext.userActionPauseToggleAudioFx = (mute: boolean) =>{
      //const sound = new Three_Audio(listener);
      if(mute)
      {
        sound.pause();

        (self as any).mixerHead.activeClip.paused = true;
        (self as any).mixerTeeth.activeClip.paused = true;
      }else{
        sound.play();

        (self as any).mixerHead.activeClip.paused = false;
        (self as any).mixerTeeth.activeClip.paused = false;
      }
    };

// create a global audio source


    scubeContext.userActionPlayAudioFx = (data: any) => {
// load a sound and set it as the Audio object's buffer
      const audioLoader = new Three_AudioLoader();

      //prepare animation clips
      // console.log(testVisemeAmyScenarioJson.block_0.visemes.length);

      const totalBlockSec = data.block.TotalSeconds;

      const allTracks = [];

      let lastOffset = 0;
      //for (let i = 0; i < testVisemeAmyScenarioJson.Hello.visemes.length; i++) {
      for (let i = 0; i < data.visemeBlock.visemes.length; i++) {
        const curViseme = data.visemeBlock.visemes[i];
        const curVisemeDef = visemesByNumber[curViseme.v];

        const visemeTimeSec = (curViseme.o - lastOffset) / 1000;

        const curOffset = curViseme.o / 1000;

        const minVisemeBlendTime = Math.min(0.15, visemeTimeSec);

        //
        // console.log(curVisemeDef.playerViseme);
        // console.log(visemeTimeSec);
        // console.log([0.0 + curOffset, minVisemeBlendTime + curOffset, visemeTimeSec + curOffset + 0.15]);

        //console.log([0.0 + curOffset, minVisemeBlendTime + curOffset, totalBlockSec]);
        //check last item
        if (i == data.visemeBlock.visemes.length - 1) {


          const curStep = new NumberKeyframeTrack(
            '.morphTargetInfluences[' + curVisemeDef.playerViseme + ']',
            [0.0 + curOffset, minVisemeBlendTime + curOffset, totalBlockSec],//set to end
            [0.0, 0.45, 0.0],
            InterpolateLinear
          );

          allTracks.push(curStep);
        } else {
          const curStep = new NumberKeyframeTrack(
            '.morphTargetInfluences[' + curVisemeDef.playerViseme + ']',
            [0.0 + curOffset, minVisemeBlendTime + curOffset, visemeTimeSec + curOffset + 0.15],
            [0.0, 0.45, 0.0],
            InterpolateLinear
          );

          allTracks.push(curStep);
        }


        lastOffset = curViseme.o;
      }
      //
      const fullClip2 = new AnimationClip('myclip' + data.block.BlockId, undefined, allTracks, AdditiveAnimationBlendMode);


      console.log({duration: lastOffset / 1000});


      (self as any).mixerHead.stopAllAction();
      (self as any).mixerTeeth.stopAllAction();
      // // //const fullClip = new AnimationClip('myclip', undefined, [fullV_I]);
      const fullClipActionHead = (self as any).mixerHead.clipAction(fullClip2).setDuration(totalBlockSec).setLoop(LoopOnce, 0);//.play();//lastOffset / 1000
      const fullClipActionTeeth = (self as any).mixerTeeth.clipAction(fullClip2).setDuration(totalBlockSec).setLoop(LoopOnce, 0);//.play();//lastOffset / 1000
      // fullClipAction2.play();
      fullClipActionHead.loop = LoopOnce;
      fullClipActionTeeth.loop = LoopOnce;

      console.log(data.uriAudio);

      //"/api/v1/t/" + scubeContext.TenantUriName + "/c/" + this.props.client + "/client-amyScenario/get-voice-file?scenarioTemplate=" + scenarioTemplate + "&voiceFileName=" + voiceFileName + ""
      //const uriAudio = "/api/v1/t/" + scubeContext.TenantUriName + "/c/" + this.props.client + "/client-amyScenario/get-voice-file?scenarioTemplate=" + scenarioTemplate + "&voiceFileName=" + voiceFileName + ""
      //audioLoader.load('/dapi/v1/Debug/getDebugAmyScenarioAudio?blockName=' + data.block.BlockId + '&n=' + new Date().getUTCMilliseconds(), function (buffer) {
      audioLoader.load(data.uriAudio + '&v=' + window.staticfilesversion, function (buffer) {
        if (sound.isPlaying) {
          sound.stop();
        }

        sound.setBuffer(buffer);
        sound.setLoop(false);
        //sound.setVolume(0.5);
        //sound.play();
        //scubeContext.userAudioSource = sound;
        sound.onEnded = () => {
          console.log("onEnded")
          sound.isPlaying = false
        }

        //console.log(sound.offset);
        //console.log(sound.context.currentTime);//sa meni po pauze
        //console.log(sound._progress);
        //console.log(sound._startedAt);

        (sound as any)._progress = 0;
        (sound as any)._startedAt = 0;

        sound.play(0);

        (self as any).mixerHead.activeClip = fullClipActionHead;
        (self as any).mixerTeeth.activeClip = fullClipActionTeeth;


        fullClipActionHead.play();
        fullClipActionTeeth.play();

        //console.log((self as any).mixerHead.activeClip);

        console.log('audio loaded');
      });

    };



    //console.log(meshAmy.morphTargetDictionary);

    // const eyeLookInLeftPos = meshAmy.morphTargetDictionary['eyeLookInLeft'];
    // const eyeLookOutLeftPos = meshAmy.morphTargetDictionary['eyeLookOutLeft'];
    // meshAmyEyeLeft.morphTargetInfluences[eyeLookInLeftPos] = 0.75;


    self.morphTarget = (targetName:amyMorphtargets, value:number)=>{
      const curMorphTarget = meshAmy.morphTargetDictionary[targetName];
      //console.log(targetName);
      if(curMorphTarget)
      {
        meshAmy.morphTargetInfluences[curMorphTarget] = value;
        meshAmyTeeth.morphTargetInfluences[curMorphTarget] = value;
        meshAmyEyeLeft.morphTargetInfluences[curMorphTarget] = value;
      }
    };

    const eyeTimes =  [0,   0.1, 0.3,  4.0, 4.1, 4.3,  11,   11.1,  11.3, 18];
    const eyeValues = [0.1, 2.0,  0.3,  0.1, 2.0,  0.1,  0.3,  2.0,    0.1,  0.3];

    const eyeBlinkLeftTarget = meshAmyEyeLeft.morphTargetDictionary['eyeBlinkLeft'];
    const eyeBlinkRightTarget = meshAmyEyeLeft.morphTargetDictionary['eyeBlinkRight'];
    //animate eyes blinking
    const fullLeftEyeBlonk = new NumberKeyframeTrack(
      '.morphTargetInfluences[' + eyeBlinkLeftTarget + ']',
      eyeTimes,
      eyeValues,
      InterpolateLinear
    );
    const fullRightEyeBlonk = new NumberKeyframeTrack(
      '.morphTargetInfluences[' + eyeBlinkRightTarget + ']',
      eyeTimes,
      eyeValues,
      InterpolateLinear
    );

    const fullEyeClip = new AnimationClip('myEyeClip', undefined, [fullLeftEyeBlonk, fullRightEyeBlonk]);
    const fullEyeClipAction2 = (self as any).mixerEyeLeft.clipAction(fullEyeClip).setDuration(18).play();
    fullEyeClipAction2.play();




    //pozor vonkajsi animacny event
    sceneEngine.curSceneContext.invokeFadeToAnimation = (newAnimationName) => {

      if (!self.modelAnimationsNamed[newAnimationName]) {
        console.log('missing animation : ' + newAnimationName);
        return;
      }

      const newAction = self.modelAnimationsNamed[newAnimationName];

      // zakomentovane animacie
      if ((newAction as any)._clip.name != 'Walking') {
        newAction.loop = LoopPingPong;
      }
      // zakomentovane animacie
      setWeight(newAction, 1);
      newAction.time = 0;

      if (self.curAction != null) {
        if ((self.curAction as any)._clip.name != (newAction as any)._clip.name)
          // iba ak su rozne
          self.curAction.crossFadeTo(newAction, 0.75, true);
      }

      self.curAction = newAction;
      ////newAction.halt(1.0);
      newAction.play();
    };

    sceneEngine.startScene();
  }

  loadModels();
};

const CreateScene = (width: number, height: number) => {
  let result = {
  } as amy3DHolderType;

  sceneEngine.curSceneContext.amy3DHolder = result;

  // renderer
  result.renderer = new WebGLRenderer({antialias: true, alpha: true}); //, alpha: true - transparency

  //sceneHolder.renderer.setClearColor(sceneHolder.matrixClearColor, 0);

  result.amyClearColor = new Color(0x010000);
  result.matrixClearColor = new Color(0x010000);
  result.renderer.setClearColor(0xffffff, 0);
  //result.renderer.setClearAlpha(0.0);
  //result.renderer.outputEncoding = sRGBEncoding;
  result.renderer.outputColorSpace =  SRGBColorSpace;
  //result.renderer.toneMapping = ACESFilmicToneMapping;//martin

  //result.bufferCamera.aspect = 1.0;

  // Create a different scene to hold our buffer objects
  result.bufferScene = new Scene();

  result.bufferCamera = new PerspectiveCamera(20, width / height, 0.1, 2000) as any;

  //result.bufferCamera = new OrthographicCamera(-100,100, 100,-100,1,1000);

  result.bufferCamera.position.set(0, 170, 400.0);
  result.bufferCamera.lookAtPosition = new Vector3(0, 120, 0);

  result.bufferCamera.lookAt(result.bufferCamera.lookAtPosition);

  result.bufferCamera.updateProjectionMatrix();

  const hemisphereLight = new HemisphereLight(0xe6ffff, 0x555555, 3.0);

  hemisphereLight.position.set(0, 500, 0);
  result.bufferScene.add(hemisphereLight);

  const dlight = new DirectionalLight(0xffffff, 2.0);
  dlight.position.set(-300, 200, 400);
  dlight.castShadow = true;
  dlight.shadow.camera.top = 50;
  dlight.shadow.camera.bottom = -50;
  dlight.shadow.camera.left = -50;
  dlight.shadow.camera.right = 50;
  result.bufferScene.add(dlight);

  //result.bufferScene.add(new DirectionalLightHelper(dlight, 5));

  reloadModel(result);
  //init particles
  initControls(result);

  // clock
  result.clock = new Clock(true);

  return result;
};

function setWeight(action: AnimationAction, weight: number) {
  action.enabled = true;
  action.setEffectiveTimeScale(1);
  action.setEffectiveWeight(weight);
}

const Amy3DLazy = ({
                     amyScene,
                     amyModel,
                     className,
                     dimensions,
                   }: {
  amyScene: sceneType;
  amyModel: string;
  className?: string;
  dimensions: { width: number; height: number; };
}) => {
  const mount = useRef<any>(null);
  const resizeRef = useRef<(width: number, height: number)=>void>(null);
  const [isAnimating] = useState(true);
  const controls = useRef<{ start: () => void; stop: () => void } | null>(null);

  useEffect(() => {
    //console.log('init amy webgl');

    let width = dimensions.width;
    let height = dimensions.height;
    let frameId: number | null;

    sceneEngine.init(amyScene, amyModel);
    const sceneHolder = CreateScene(width, height);

    //init resize
    if (sceneEngine.curSceneContext) {
      sceneEngine.curSceneContext.invokeSetSize = (width, height) => {
        handleResize(width, height);
      };
    }

    const calculateEyes = (quaternion: Quaternion, globalTime: number, amy3DHolder: amy3DHolderType) => {
// Create a rotation matrix from the Quaternion
      //const rotationMatrix = new Matrix4();
      //rotationMatrix.makeRotationFromQuaternion(quaternion);
      // const element8 = rotationMatrix.elements[8];
      // const element6 = rotationMatrix.elements[6];

      const element8_2 = 2 * quaternion.x * quaternion.z + 2 * quaternion.y * quaternion.w;
      const element6_2 = 2 * quaternion.y * quaternion.z + 2 * quaternion.x * quaternion.w;//https://threejs.org/docs/#api/en/math/Matrix4

      //console.log({e6: element6, e8: element8, e6_1: element6_2, e8_2: element8_2});

      const angleHorizontal = (Math.asin(Math.abs(element8_2)) + 0.2) * 2. / Math.PI;
      const angleVertical = (Math.asin(Math.abs(element6_2)) + 0.1) * 2. / Math.PI;

      //console.log({h: angleHorizontal, v: angleVertical});

      //console.log({hor:angleHorizontal});
      //casovac

      const eyeCorrection = 0.2;
      const horizontalShift = 0.03 * Math.sin(globalTime / 2.) * Math.min(Math.exp(-globalTime * globalTime / 4 * Math.cos(globalTime)), 10.);
      const verticalShift = 0.02 * Math.cos(globalTime / 2.) * Math.min(Math.exp(-globalTime * globalTime / 4 * Math.cos(globalTime)), 10.);

      const leftEyeAngle = angleHorizontal + horizontalShift;
      const rightEyeAngle = angleHorizontal + horizontalShift + eyeCorrection;

      if (leftEyeAngle >= 0) {
        amy3DHolder.morphTarget(amyMorphtargets.eyeLookInLeft, Math.max(Math.min(leftEyeAngle, 1.), 0.) / 1.5);
      } else {
        amy3DHolder.morphTarget(amyMorphtargets.eyeLookOutLeft, Math.max(Math.min(Math.abs(leftEyeAngle), 1.), 0.));
      }

      if (rightEyeAngle >= 0) {
        amy3DHolder.morphTarget(amyMorphtargets.eyeLookOutRight, Math.max(Math.min(rightEyeAngle, 1.), 0.));
      } else {
        amy3DHolder.morphTarget(amyMorphtargets.eyeLookInRight, Math.max(Math.min(Math.abs(rightEyeAngle), 1.), 0.) / 1.5);
      }

      if ((angleVertical + verticalShift) >= 0) {
        amy3DHolder.morphTarget(amyMorphtargets.eyeLookDownLeft, Math.max(Math.min(angleVertical + verticalShift, 1.), 0.));
        amy3DHolder.morphTarget(amyMorphtargets.eyeLookDownRight, Math.max(Math.min(angleVertical + verticalShift, 1.), 0.));
      } else {
        amy3DHolder.morphTarget(amyMorphtargets.eyeLookUpLeft, Math.max(Math.min(Math.abs(angleVertical + verticalShift), 1.), 0.));
        amy3DHolder.morphTarget(amyMorphtargets.eyeLookUpRight, Math.max(Math.min(Math.abs(angleVertical + verticalShift), 1.), 0.));
      }
    }



    let renderCounter = 0;
    const renderScene = () => {
      renderCounter++;

      //if (renderCounter % 5 !== 0) return;//spomali render a setri mobil

      const delta = sceneHolder.clock.getDelta();
      const globalTime = sceneHolder.clock.getElapsedTime();
      
      window.delta = globalTime;

      //update scene parts
      if (sceneHolder.mixer) sceneHolder.mixer.update(delta);
      if ((sceneHolder as any).mixerHead) {
        (sceneHolder as any).mixerHead.update(delta);

        if ((sceneHolder as any).mixerHead.activeClip) {
          window.mixerHeadTime = (sceneHolder as any).mixerHead.activeClip.time;
        }
      }
      if ((sceneHolder as any).mixerTeeth) (sceneHolder as any).mixerTeeth.update(delta);
      if ((sceneHolder as any).mixerEyeLeft) (sceneHolder as any).mixerEyeLeft.update(delta);
      if ((sceneHolder as any).mixerEyeRight) (sceneHolder as any).mixerEyeRight.update(delta);


      //head bones positions
      if((sceneHolder as any).headBone) {
        //const boneWorldPos = new Vector3();
        //const boneWorldDirectornPos = new Vector3(0,0,1);
        const boneWorldDirectornPosQ = new Quaternion();
        //(sceneHolder as any).headBone.getWorldPosition(boneWorldPos);
        //(sceneHolder as any).headBone.getWorldDirection(boneWorldDirectornPos);
        (sceneHolder as any).headBone.getWorldQuaternion(boneWorldDirectornPosQ);
        //window.amyModelHeadVector = boneWorldPos;

        //console.log((sceneHolder as any).headBone.rotation);//rotation is not updated and recalculated, gpu

        //const e1 = new Euler( 0, 0, 0, 'XYZ' );
        //e1.setFromQuaternion(boneWorldDirectornPosQ);

        //window.amyModelHeadDirectionEuler = e1;
        window.amyModelHeadDirectionQ = boneWorldDirectornPosQ;

        // console.log(boneWorldDirectornPos);
        // console.log(boneWorldDirectornPosQ);
        //console.log(e1);

        calculateEyes(boneWorldDirectornPosQ, globalTime, sceneHolder);
      }

      //precalculate eyes




      //sceneHolder.renderer.setClearColor(sceneHolder.amyClearColor, 1);
      sceneHolder.renderer.render(sceneHolder.bufferScene, sceneHolder.bufferCamera);
    };

    const handleResize = (width: number, height: number) => {
      //console.log('amy webgl handleResize');

      sceneHolder.renderer.setSize(width, height);
      sceneHolder.bufferCamera.aspect = width / height;
      sceneHolder.bufferCamera.updateProjectionMatrix();

      renderScene();
    };

    resizeRef.current = handleResize;

    const animate = () => {
      renderScene();
      frameId = window.requestAnimationFrame(animate);
    };

    const start = () => {
      if (!frameId) {
        frameId = requestAnimationFrame(animate);
      }
    };

    const stop = () => {
      if (frameId) {
        cancelAnimationFrame(frameId);
      }
      frameId = null;

      if(sceneHolder.sound) {
        try {
          sceneHolder.sound.stop();
        }catch{
          //skip not played audio
        }
      }
    };

    mount.current.appendChild(sceneHolder.renderer.domElement);

    const localMount = mount.current;

    start();

    controls.current = {start, stop};

    handleResize(dimensions.width, dimensions.height);

    return () => {
      stop();
      if (localMount) {
        localMount.removeChild(sceneHolder.renderer.domElement);
      }
    };
  }, [
    amyScene,
    amyModel,
  ]);

  useEffect(() => {
    resizeRef.current?.(dimensions.width, dimensions.height);
  }, [dimensions.width, dimensions.height]);

  useEffect(() => {
    if (isAnimating) {
      controls.current?.start();
    } else {
      controls.current?.stop();
    }
  }, [isAnimating]);

  return (
    <div
      className={className}
      ref={mount}
      //onClick={() => setAnimating(!isAnimating)}
      style={{width: dimensions.width, height: dimensions.height}}
    />
  );
};

export default Amy3DLazy;
